<template>
  <v-container v-if="$route.name === 'OpenDiss'">
    <v-card style="min-height: 500px">
      <v-card-title class="title subprimary">Диссертации РХТУ им. Д.И. Менделеева
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-1 ma-1"
          label="Фамилия"
          v-model="lastName"
          v-on:keyup.enter="getItems"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Имя"
          v-model="firstName"
          v-on:keyup.enter="getItems"
        >
        </v-text-field>
        <v-text-field
          class="pa-1 ma-1"
          label="Отчество"
          v-model="patronymic"
          v-on:keyup.enter="getItems"
        >
        </v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItemsClear" color="primary" icon flat><v-icon>clear</v-icon></v-btn>
          </template>
          <span>Очистить поля ввода</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="getItems" color="primary" icon flat><v-icon>search</v-icon></v-btn>
          </template>
          <span>Поиск</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <div :key="i" v-for="item, i in items">
          <v-card class="pa-2 ma-2 elevation-3">

            <v-card-text class="title text-xs-left">
              <router-link    :to=" getRouteParam(item)"><strong>{{item.lastName[0].text}}
                {{item.firstName[0].text}} <span v-if="item.patronymic !== null">{{ item.patronymic[0].text }}</span></strong></router-link>

            </v-card-text>

            <v-card-text class="title text-xs-left"><strong> Тема диссертационной работы:&nbsp;</strong>
              {{item.thesisTopic[0].text}}
            </v-card-text>
            <v-card-title class="title "><strong>Дата проведения защиты:&nbsp;</strong>
              {{item.protectionDate}}
            </v-card-title>

            <v-card-title class="title text-xs-left">
              <strong> Соискатель ученой степени:&nbsp;</strong> {{item.academicDegree.name[0].text}}
            </v-card-title>
            <v-card-title class="title" v-if="item.scientificField !==undefined">
              <strong>Научные специальности:</strong>
            </v-card-title>

            <div :key="j" v-for="it, j in item.scientificField">
              <v-card-title class="title" v-if="it.scientificField !==undefined"> {{it.scientificField.scientificSpecialty.code}}
                {{it.scientificField.scientificSpecialty.name[0].text}} ({{it.scientificField.scientificIndustry.name[0].text}} науки)
              </v-card-title>
<!--              <v-card-title class="title" v-if="it.scientificField !==undefined"><strong>Область науки:&nbsp;</strong>{{it.scientificField.scientificIndustry.name[0].text}}-->
<!--                науки-->
<!--              </v-card-title>-->
            </div>

          </v-card>
        </div>
      </v-card-text>
      <v-layout align-space-around justify-center row fill-height>
        <div class="text-xs-center">
          <v-pagination
            v-model="page"
            :length="pageLength"
          ></v-pagination>
        </div>
      </v-layout>
    </v-card>
  </v-container>
  <div v-else>
    <router-view :key="$route.fullPath"></router-view>
  </div>

</template>

<script>
    import urls from "../../../modules/petition/urls"
    import {makeGetRequest} from "../../../helper";

    export default {
        name: "OpenDiss",
        data: function () {
            return {
                lastName: "",
                firstName: "",
                patronymic: "",
                page: 1,
                total: 0,
                maxElem: 10,
                items: [],
                loading: true,
            }
        },
        created() {
            this.getItems()
            this.$store.commit('mainpage/changeTitle', 'Объявления о защитах диссертаций');
        },
        computed: {
            // геттер вычисляемого значения
            pageLength: function () {
                if (this.total < this.maxElem)
                    return 1
                else
                    return Math.ceil(this.total / this.maxElem)
            }
        },
        watch: {
            page: {
                handler() {
                    this.getItems()
                },
                deep: true
            }
        },
        methods: {
          getRouteParam(item){
            let paramR = { name: 'DetailAuthor', params: {uid: item.uid}}
            if(this.$route.params.token){
              paramR = { name: 'DetailAuthor', params: {uid: item.uid,token:this.$route.params.token}}
            }
            return paramR
          },
            loadScientificField() {
                for (let key in this.items) {
                    let i = key
                    let urlsci = new URL(urls.getUrl(this.items[key].scientificField.url_name, this.items[key].scientificField.action))
                    let params = this.items[key].scientificField.get_params
                    urlsci.search = new URLSearchParams(params).toString();
                    let sys = true
                    makeGetRequest(urlsci).then(resp => {
                        if (!resp.ok) {
                            sys = false
                        }
                        return resp.json()
                    }).then(json => {
                        if (!sys)
                            this.$router.push({name: 'PageNotFound'})
                        this.items[i].scientificField = json.results

                    })
                }
            },
            getItemsClear(){
                this.lastName = "";
                this.firstName = "";
                this.patronymic = "";
                this.getItems()
            },
            getItems() {
                this.loading = true
                let url = process.env.VUE_APP_API_HOST + "council/public/case/models/candidate_case/" + "?page=" + this.page + "&page_size=" + this.maxElem
                let sys = true
                let urlsci = new URL(process.env.VUE_APP_API_HOST + "council/public/case/models/candidate_case/")
                let params = {};
                params.page =  this.page;
                params.page_size =  this.maxElem;
                if(this.lastName.length !== 0)
                  params.lastName__icontains = this.lastName
                if(this.firstName.length !== 0)
                    params.firstName__icontains = this.firstName
                if(this.patronymic.length !== 0)
                    params.patronymic__icontains = this.patronymic
                urlsci.search = new URLSearchParams(params).toString();

                makeGetRequest(urlsci).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.items = json.results
                    this.total = json.count
                    this.loading = false
                    this.loadScientificField()
                })
            },
        },
    }
</script>

<style scoped>

</style>
